<template>
  <div class="addpaper">
    <div class="choseType">
      <el-button round class="add" @click="addQues" type="primary">
        <i class="el-icon-circle-plus"></i>添加试题
      </el-button>
      <el-button @click="madePaper = true">从题库选择试题</el-button>
      <el-button @click="madePaperquick = true">随机选择试题</el-button>
      <el-button @click="importAll = true">批量添加考试题</el-button>
    </div>
    <el-form label-position="left" :model="ruleForm" label-width="150px" ref="ruleForm" class="ruleForm">
      <template>
        <h2><b>|</b> 试卷设置</h2>
        <el-form-item label="试卷名称：">
          <el-input v-model="ruleForm.title"></el-input>
        </el-form-item>
        <el-form-item label="设置封面:">
          <el-button size="mini" @click="upload = true">点击上传</el-button>
          <div class="avatarOuter">
            <img v-if="ruleForm.cover" :src="ruleForm.cover" class="avatar" />
          </div>
        </el-form-item>
        <el-form-item label="试卷类型:">
          <el-radio-group v-model="ruleForm.type">
            <el-radio :label="3">测试卷</el-radio>
            <el-radio :label="1">测验卷</el-radio>
            <el-radio :label="2">考试卷</el-radio>
            <el-radio :label="4">顺序练习</el-radio>
            <el-radio :label="5">个人卷</el-radio>
            <i class="iconfont icon-wenhao" @click="dialogVisible = true">
              帮助</i>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="考场开放/关闭时间：">
          <el-radio-group v-model="set_time">
            <el-radio :label="0">手动调整</el-radio>
            <el-radio :label="1">定时开启/关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="考场开放时间：" v-show="set_time == 0">
          <el-date-picker v-model="ruleForm.start_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"></el-date-picker>
          (开放考场)
        </el-form-item>
        <el-form-item label="考场关闭时间：" v-show="set_time == 0">
          <el-date-picker v-model="ruleForm.end_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"></el-date-picker>
          (关闭考场)
        </el-form-item>
        <el-form-item label="考场开放时间：" v-show="set_time == 1">
          每周的
          <el-select v-model="ruleForm.weekly" placeholder="请选择">
            <el-option v-for="(item, index) in weeks" :key="index" :label="item.label" :value="item.value"
              format="HH:mm" value-format="HH:mm">
            </el-option>
          </el-select>
          <el-time-select v-model="weekly_time_start" :picker-options="{
              start: '00:00',
              step: '00:10',
              end: '23:50',
            }" placeholder="选择开放时间">
          </el-time-select>
          <el-time-select v-model="weekly_time_end" :picker-options="{
              start: '00:00',
              step: '00:10',
              end: '23:50',
            }" placeholder="选择关闭时间">
          </el-time-select>
        </el-form-item>
        <el-form-item label="试迟到禁考：" v-show="ruleForm.type == 2">
          <el-switch v-model="is_late" style="padding-right:40px"></el-switch>
          <span v-show="is_late == true">
            <el-input-number size="mini" v-model="ruleForm.late" :min="0"></el-input-number>（分钟）
          </span>
        </el-form-item>
        <!-- <el-form-item label="是否付费：" v-show="ruleForm.type == 2">
          <el-switch v-model="pay" style="padding-right:40px"></el-switch>
          <span v-show="pay == true">
            <el-input-number
              size="mini"
              v-model="ruleForm.pay"
              :min="0"
            ></el-input-number
            >（元）
          </span>
        </el-form-item> -->
        <el-form-item label="试卷答题时间：" v-show="ruleForm.type != 4">
          <el-input-number size="mini" v-model="ruleForm.minutes" :min="0"></el-input-number>（分钟）
        </el-form-item>
        <el-form-item label="题目随机排序：">
          <el-switch v-model="ruleForm.is_random"></el-switch>
        </el-form-item>
        <el-form-item label="答案随机排序：">
          <el-switch v-model="ruleForm.is_option_random"></el-switch>
        </el-form-item>
        <el-form-item label="试卷说明：">
          <el-input size="mini" type="textarea" v-model="ruleForm.brief"></el-input>
        </el-form-item>
        <el-form-item label="结束后跳转网址：" v-show="ruleForm.type == 2">
          <el-input size="mini" v-model="ruleForm.skip_url"></el-input>
        </el-form-item>
        <el-form-item label="考试须知：">
          <quill-editor v-model="ruleForm.knows" class="ql-editor" :options="editorOption"
            ref="myQuillEditor"></quill-editor>

          <el-upload class="editorUploader" action="/" :show-file-list="false" :before-upload="beforeUpload"
            accept=".png,.jpg">
            <el-button class="el-icon-plus avatar-uploader-icon uploadBtn"></el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="考试所需积分：">
          <el-input-number size="mini" :min="0" v-model="ruleForm.points"></el-input-number>
        </el-form-item>
        <el-form-item label="考试完成奖励积分：">
          <el-input-number size="mini" :min="0" v-model="ruleForm.get_points"></el-input-number>
        </el-form-item>
      </template>

      <template>
        <h2><b>|</b> 分数设置</h2>
        <el-form-item label="当前试题总数：">
          <span class="ques_sum">
            {{
            ruleForm.radio_sum +
            ruleForm.multi_sum +
            ruleForm.judge_sum +
            ruleForm.cloze_sum
            }}（道）</span>
          <span class="ques_sum">
            单选题共：{{ ruleForm.radio_sum }}（道）
          </span>
          <span class="ques_sum">
            多选题共：{{ ruleForm.multi_sum }}（道）
          </span>
          <span> 判断题共：{{ ruleForm.judge_sum }}（道） </span>
          <span> 填空题共：{{ ruleForm.cloze_sum }}（道） </span>
        </el-form-item>
        <el-form-item label="总分：" v-show="ruleForm.type != 4">
          <span v-show="ruleForm.type != 5">{{
            ruleForm.radio_sum * ruleForm.radio_score +
            ruleForm.multi_sum * ruleForm.multi_score +
            ruleForm.judge_sum * ruleForm.judge_score +
            ruleForm.cloze_sum * ruleForm.cloze_score
            }}（分）</span>
          <span v-show="ruleForm.type == 5">{{
            ruleForm.select_num * ruleForm.que_score
            }}</span>
        </el-form-item>
        <el-form-item label="题目个数：">{{
          ruleForm.radio_sum +
          ruleForm.multi_sum +
          ruleForm.judge_sum +
          ruleForm.cloze_sum
          }}（个）</el-form-item>

        <el-form-item label="及格分数：" v-show="ruleForm.type != 4">
          <el-input-number size="mini" placeholder="0" v-model="ruleForm.pass_score" :min="0"></el-input-number>（分）
        </el-form-item>
        <el-form-item label="单选题每题：" v-show="ruleForm.type != 5 && ruleForm.type != 4">
          <el-input-number size="mini" placeholder="0" :disabled="!setRadio" v-model="ruleForm.radio_score"
            :min="0"></el-input-number>（分）
        </el-form-item>
        <el-form-item label="多选题每题：" v-show="ruleForm.type != 5 && ruleForm.type != 4">
          <el-input-number size="mini" placeholder="0" :disabled="!setCheck" v-model="ruleForm.multi_score"
            :min="0"></el-input-number>（分）
        </el-form-item>
        <el-form-item label="判断题每题：" v-show="ruleForm.type != 5 && ruleForm.type != 4">
          <el-input-number size="mini" placeholder="0" :disabled="!setJudge" v-model="ruleForm.judge_score"
            :min="0"></el-input-number>（分）
        </el-form-item>
        <el-form-item label="填空题每题：" v-show="ruleForm.type != 5 && ruleForm.type != 4">
          <el-input-number size="mini" placeholder="0" :disabled="!setCloze" v-model="ruleForm.cloze_score"
            :min="0"></el-input-number>（分）
        </el-form-item>
        <el-form-item label="题目分值：" v-show="ruleForm.type == 5 && ruleForm.type != 4">
          <el-input-number size="mini" placeholder="0" v-model="ruleForm.que_score" :min="0"></el-input-number>（分）
        </el-form-item>
        <el-form-item label="抽题个数：" v-show="ruleForm.type == 5 && ruleForm.type != 4">
          <el-input-number size="mini" placeholder="0" v-model="ruleForm.select_num" :min="1"
            :max="ruleForm.num"></el-input-number>（个）
        </el-form-item>
      </template>
      <template>
        <h2 v-show="ruleForm.type != 4"><b>|</b> 监考设置</h2>
        <el-form-item label="显示正确答案：" v-show="ruleForm.type != 2 && ruleForm.type != 4">
          <el-switch v-model="ruleForm.is_show_answer"></el-switch>
        </el-form-item>
        <el-form-item label="显示重做按钮：" v-show="ruleForm.type == 3">
          <el-switch v-model="ruleForm.is_repeat"></el-switch>
        </el-form-item>
        <el-form-item label="人脸识别验证：" v-show="ruleForm.type == 2">
          <el-switch v-model="ruleForm.is_verify"></el-switch>
        </el-form-item>
        <el-form-item label="AI智能监考：" v-show="ruleForm.type == 2">
          <el-switch v-model="ruleForm.ai"></el-switch>
        </el-form-item>
        <el-form-item label="考试须知弹框：" v-show="ruleForm.type == 2">
          <el-switch v-model="ruleForm.notice"></el-switch>
        </el-form-item>
        <el-form-item label="考试中途拍照：" v-show="ruleForm.type == 2">
          <el-input-number size="mini" placeholder="0" v-model="ruleForm.verify_nums" :min="0"
            :max="99"></el-input-number>（设置的次数决定在考试中途系统对考生进行拍照的次数）
        </el-form-item>
      </template>
    </el-form>
    <p class="submint-btn">
      <el-button type="primary" @click="onSubmit">保存试卷</el-button>
      <el-button type="success" @click="link('PaperListIndex')">返回试卷列表</el-button>
    </p>
    <div class="ques">
      <el-card class="box-card" v-for="(ques, i) in questions" :key="i">
        <div class="queTitle">
          <p>{{ i + 1 }}：</p>
          <div class="queName" v-html="ques.name"></div>
          <p class="queType">
            <strong>（ <span v-if="ques.type == 1">单选题</span>
              <span v-if="ques.type == 2">多选题</span>
              <span v-if="ques.type == 3">判断题</span>
              <span v-if="ques.type == 4">填空题</span>）</strong>
          </p>
        </div>

        <p class="item_option" v-for="(option, index) in ques.options" :key="index">
          <span><span v-show="ques.type != 4"> {{ arr[index] }}:</span>{{ option.name }}</span>
          <b class="is_right" v-if="option.is_right">(正确选项)</b>
        </p>
        <!-- <span class="insertQues" @click="handleInsert(i)">在此题后插入新题</span> -->
        <p class="oprate">
          <el-button icon="el-icon-edit-outline" size="mini" @click="handleEdit(ques, i)">编辑</el-button>
          <el-button icon="el-icon-delete" @click="handleDelete(ques, i)" size="mini">删除</el-button>
        </p>
      </el-card>
    </div>
    <el-dialog width="300px" :close-on-click-modal="false" :visible.sync="todel">
      <p>确定删除吗？</p>
      <div style="text-align: right; margin: 0">
        <el-button size="mini" type="text" @click="todel = false">取消</el-button>
        <el-button size="mini" type="text" @click="toDelete">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="试题" :visible.sync="addQuestion" width="60%" :close-on-click-modal="false">
      <addQuestion :ques="ques" :editType="editType" @saveQuestion="saveQuestion"></addQuestion>
    </el-dialog>
    <el-dialog title="点击上传" :visible.sync="upload" :close-on-click-modal="false" width="30%">
      <upload @uploadCover="uploadCover"></upload>
      <p class="msg">上传图片比例4:3</p>
    </el-dialog>
    <el-dialog title="组卷" :visible.sync="madePaper" :close-on-click-modal="false" width="1000px">
      <madePaper @handleMadePaper="handleMadePaper"></madePaper>
    </el-dialog>
    <el-dialog title="批量添加试题" :visible.sync="importAll" :close-on-click-modal="false" width="1000px">
      <importData :paper_id="id"></importData>
    </el-dialog>
    <el-dialog title="请选择" :close-on-click-modal="false" :visible.sync="madePaperquick" width="1100px">
      <el-row :gutter="30">
        <el-col :span="6">
          单选题：
          <el-input-number v-model="radio" size="small" :min="0"></el-input-number>道
        </el-col>
        <el-col :span="6">
          <el-cascader size="small" :options="chapter" placeholder="选择科目/章节" v-model="radioChapter_id"
            clearable></el-cascader>
        </el-col>
        <el-col :span="6">
          <el-select size="small" v-model="radioDifficult" clearable placeholder="选择难易度">
            <el-option v-for="item in difficulty" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-input size="small" v-model="radioKeyword" placeholder="关键词"></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="30">
        <el-col :span="6">
          多选题：
          <el-input-number v-model="checkbox" size="small" :min="0"></el-input-number>道
        </el-col>
        <el-col :span="6">
          <el-cascader size="small" :options="chapter" placeholder="选择科目/章节" v-model="checkboxChapter_id"
            clearable></el-cascader>
        </el-col>
        <el-col :span="6">
          <el-select size="small" v-model="checkboxDifficult" clearable placeholder="选择难易度">
            <el-option v-for="item in difficulty" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-input size="small" v-model="checkboxKeyword" placeholder="关键词"></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="30">
        <el-col :span="6">
          判断题：
          <el-input-number v-model="judgement" size="small" :min="0"></el-input-number>道
        </el-col>
        <el-col :span="6">
          <el-cascader size="small" :options="chapter" placeholder="选择科目/章节" v-model="judgementChapter_id"
            clearable></el-cascader>
        </el-col>
        <el-col :span="6">
          <el-select size="small" v-model="judgementDifficult" clearable placeholder="选择难易度">
            <el-option v-for="item in difficulty" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-input size="small" v-model="judgementKeyword" placeholder="关键词"></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="30">
        <el-col :span="6">
          填空题：
          <el-input-number v-model="cloze" size="small" :min="0"></el-input-number>道
        </el-col>
        <el-col :span="6">
          <el-cascader size="small" :options="chapter" placeholder="选择科目/章节" v-model="clozeChapter_id"
            clearable></el-cascader>
        </el-col>
        <el-col :span="6">
          <el-select size="small" v-model="clozeDifficult" clearable placeholder="选择难易度">
            <el-option v-for="item in difficulty" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-input size="small" v-model="clozeKeyword" placeholder="关键词"></el-input>
        </el-col>
      </el-row>

      <div class="zujuan">
        <el-button type="primary" @click="quickMadePaper">确定</el-button>
      </div>
    </el-dialog>
    <!-- ?弹框 -->
    <el-dialog title="" :visible.sync="dialogVisible" width="30%" center>
      <div class="warning">
        <p>
          <span>测试卷：</span>正式考试卷之前的测试使用，不记录成绩，可把试卷类型转换为考试卷（正式卷）。
        </p>
        <p>
          <span>测验卷：</span>学员答卷后，系统会显示每道题回答是否正确。一旦有人提交，试卷将不能再做修改。
        </p>
        <p>
          <span>考试卷：</span>正式考试使用。一旦有人提交，试卷将不能再进行修改。
        </p>
        <p>
          <span>顺序练习：</span>不记录成绩，将题库内出卷者选中的一批题目遍寻一遍进行练习。学员回答后系统当即给出正确与否。
        </p>
        <p>
          <span>个人卷：</span>出卷者从题库中设定一批题目后，考生每次进入考试，在该批题目中随机抽取题目组卷。
        </p>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import AddQuestion from "../components/addQuestion";
  import MadePaper from "../components/madePaper";
  import ImportData from "../components/importData";
  import Upload from "../components/upload";
  import md5 from "js-md5"; //md5加密
  import * as qiniu from "qiniu-js";
  import "quill/dist/quill.core.css";
  import "quill/dist/quill.snow.css";
  import "quill/dist/quill.bubble.css";
  import { Quill, quillEditor } from "vue-quill-editor";
  import quillConfig from "../../../assets/js/quill-config";

  export default {
    components: { AddQuestion, Upload, MadePaper, ImportData, quillEditor },
    data() {
      return {
        testType: "",
        dialogVisible: false,
        editType: null,
        ruleForm: {},
        imageUrl: "",
        addQuestion: false,
        questions: [], //所有考题
        ques: null, //被编辑的考题
        editIndex: null, //编辑的考题索引
        url: "",
        upload: false,
        madePaper: false,
        madePaperquick: false,
        importAll: false,
        radio: 0,
        radioChapter_id: null,
        radioDifficult: "",
        radioKeyword: "",
        checkbox: 0,
        checkboxChapter_id: null,
        checkboxDifficult: "",
        checkboxKeyword: "",
        judgement: 0,
        judgementChapter_id: null,
        judgementDifficult: "",
        judgementKeyword: "",
        cloze: 0,
        clozeChapter_id: null,
        clozeDifficult: "",
        clozeKeyword: "",
        chapter: [],
        difficulty: ["A", "B", "C", "D", "E"],
        arr: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"],
        setRadio: false,
        setCheck: false,
        setJudge: false,
        setCloze: false,
        todel: false,
        params: {},
        md: "", //试题名+选项,
        id: "",
        weeks: [
          {
            value: 1,
            label: "周一",
          },
          {
            value: 2,
            label: "周二",
          },
          {
            value: 3,
            label: "周三",
          },
          {
            value: 4,
            label: "周四",
          },
          {
            value: 5,
            label: "周五",
          },
          {
            value: 6,
            label: "周六",
          },
          {
            value: 7,
            label: "周日",
          },
        ],
        is_late: false,
        set_time: 0,
        weekly_time_start: "",
        weekly_time_end: "",
        pay: false,
        editorOption: quillConfig,
        CoverputExtra: {
          mimeType: ["image/png", "image/jpg", "image/jpeg"],
        },
        config: {
          useCdnDomain: true,
        },
        token: "",
      };
    },
    created() {
      this.init();
      this.getChapter();
      this.id = this.$route.params.id;
      this.qiniuToken();
    },
    mounted() {
      quillConfig.register(Quill);
      quillConfig.initButton();
    },
    methods: {
      init() {
        let _this = this;
        this.setRadio = false;
        this.setCheck = false;
        this.setJudge = false;
        this.setCloze = false;
        let id = _this.$route.params.id;
        this.$http
          .get(process.env.VUE_APP_URL + "paperInfo/" + id)
          .then(function (data) {
            if (data.data.code == 200) {
              _this.ruleForm = data.data.data;
              if (_this.ruleForm.is_random) {
                _this.ruleForm.is_random = true;
              } else {
                _this.ruleForm.is_random = false;
              }
              if (_this.ruleForm.is_verify) {
                _this.ruleForm.is_verify = true;
              } else {
                _this.ruleForm.is_verify = false;
              }
              if (_this.ruleForm.is_option_random) {
                _this.ruleForm.is_option_random = true;
              } else {
                _this.ruleForm.is_option_random = false;
              }
              if (_this.ruleForm.is_show_answer) {
                _this.ruleForm.is_show_answer = true;
              } else {
                _this.ruleForm.is_show_answer = false;
              }
              if (_this.ruleForm.is_repeat) {
                _this.ruleForm.is_repeat = true;
              } else {
                _this.ruleForm.is_repeat = false;
              }
              if (_this.ruleForm.weekly == 0) {
                _this.ruleForm.weekly = "";
                _this.set_time = 0;
              } else {
                _this.set_time = 1;
                _this.weekly_time_start = _this.ruleForm.weekly_time.split(
                  "-"
                )[0];
                _this.weekly_time_end = _this.ruleForm.weekly_time.split("-")[1];
              }
              if (_this.ruleForm.ai == 0) {
                _this.ruleForm.ai = false;
              } else {
                _this.ruleForm.ai = true;
              }
              if (_this.ruleForm.notice == 0) {
                _this.ruleForm.notice = false;
              } else {
                _this.ruleForm.notice = true;
              }
              if (_this.ruleForm.late == 0) {
                _this.is_late = false;
              } else {
                _this.is_late = true;
              }
              _this.ruleForm.pay == 0;
              _this.ruleForm.minutes =
                _this.ruleForm.minutes != 0 ? _this.ruleForm.minutes : 60;
              _this.ruleForm.pass_score = _this.ruleForm.pass_score
                ? _this.ruleForm.pass_score
                : 60;
              // if (_this.ruleForm.pay == 0) {
              //   _this.pay = false
              // } else {
              //   _this.pay = true
              // }
              if (_this.ruleForm.question.length > 0) {
                _this.ruleForm.question.forEach((item) => {
                  item.options.forEach((opt) => {
                    if (opt.is_right == 0) {
                      opt.is_right = false;
                    } else {
                      opt.is_right = true;
                    }
                  });
                  if (item.type == 1) {
                    _this.setRadio = true;
                  } else if (item.type == 2) {
                    _this.setCheck = true;
                  } else if (item.type == 3) {
                    _this.setJudge = true;
                  } else if (item.type == 4) {
                    _this.setCloze = true;
                  }
                });
              }
            } else {
              _this.$message.error(data.data.msg);
            }

            _this.questions = _this.ruleForm.question;
          })
          .catch(function (error) {
            _this.$message.error({ message: "网络错误,请刷新界面重试" });
            return;
          });
      },
      getChapter() {
        let _this = this;
        _this.$http
          .get(process.env.VUE_APP_URL + "chapter")
          .then(function (data) {
            if (data.data.code == 200) {
              let chapter = data.data.data;
              let arr = [];
              if (chapter) {
                chapter.forEach((item) => {
                  let obj = {
                    label: item.name,
                    value: item.id,
                    children: [],
                  };
                  if (item.children) {
                    item.children.forEach((ch) => {
                      obj.children.push({
                        value: ch.id,
                        label: ch.name,
                      });
                    });
                  }
                  arr.push(obj);
                });
                _this.chapter = arr;
              }
            } else {
              _this.$message.error(data.data.msg);
            }
          })
          .catch(function (error) {
            _this.$message.error({ message: "网络错误,请刷新界面重试" });
            return;
          });
      },
      uploadCover(url) {
        //console.log(url)
        this.ruleForm.cover = url;
        this.upload = false;
      },
      saveQuestion(formData) {
        let _this = this,
          params = JSON.parse(JSON.stringify(formData)),
          options = JSON.stringify(params.options);
        params.options = options;
        if (this.ques) {
          //如果为编辑修改考题，则将修改后的考题将之前的替换  +(params.is_insert?true:false)+(params.is_sync?true:false)
          let md = md5(params.name + params.keyword),
            options = JSON.parse(JSON.stringify(formData.options));
          options.forEach((item) => {
            md += md5(item.name);
          });

          if (
            md != _this.md ||
            (md == _this.md && !params.is_bank && params.is_insert)
          ) {
            _this.$http
              .post(process.env.VUE_APP_URL + "questionUpdate", params)
              .then(function (data) {
                if (data.data.code == 200) {
                  _this.$message.success("修改成功！");
                  formData.id = data.data.data.id;
                  // _this.questions.splice(_this.editIndex,1,formData);
                  _this.init();
                  _this.addQuestion = false;
                } else {
                  _this.$message.error(data.data.msg);
                }
              })
              .catch(function (error) {
                _this.$message.error("网络错误,请刷新界面重试");
                return;
              });
          } else {
            _this.$message.warning("您并未对该题目进行修改！");
            return;
          }
        } else {
          //如果是新增
          _this.$http
            .post(process.env.VUE_APP_URL + "questionInsert", params)
            .then(function (data) {
              if (data.data.code == 200) {
                _this.$message.success("新增试题成功！");
                formData.id = data.data.data.id;
                _this.questions.push(formData);
                _this.init();
                window.scrollTo(0, 0);
                document.documentElement.scrollTop = 0 + "px";
                document.body.scrollTop = 0 + "px";
              } else {
                _this.$message.error(data.data.msg);
              }
            })
            .catch(function (error) {
              _this.$message.error("网络错误,请刷新界面重试");
              return;
            });
        }

        this.ques = null; //清空被编辑的考题
      },
      handleEdit(ques, i) {
        //编辑考题
        this.editType = ques.type;

        ques.is_bank ? (ques.is_bank = true) : (ques.is_bank = false); //导入题库
        if (ques.is_bank) {
          ques.is_insert = false;
          ques.is_sync = true;
        } else {
          ques.is_insert = false;
          ques.is_sync = false;
        }
        if (this.editType !== 2) {
          ques.options.forEach((item, index) => {
            if (item.is_right) {
              ques.is_right = index;
            }
          });
          this.ques = ques;
        } else {
          ques.is_right = [];
          ques.options.forEach((item, index) => {
            if (item.is_right) {
              ques.is_right.push(Number(index));
            }
          });
          this.ques = ques;
        }
        this.md = md5(ques.name + ques.keyword); //+ques.is_insert+ques.is_sync
        ques.options.forEach((item) => {
          this.md += md5(item.name);
        });
        this.editIndex = i;
        this.addQuestion = true;
      },
      handleDelete(ques, i) {
        this.params = { id: ques.id, paper_id: this.$route.params.id };
        this.todel = true;
      },
      onSubmit() {
        let _this = this,
          params = JSON.parse(JSON.stringify(_this.ruleForm)),
          startTime = new Date(params.start_time).getTime(),
          endTime = new Date(params.end_time).getTime();
        if (startTime >= endTime && _this.set_time == 0) {
          _this.$message.error("考试开始时间必须大于结束时间！");
          return;
        }
        params.is_random = params.is_random ? 1 : 0;
        params.is_verify = params.is_verify ? 1 : 0;
        params.is_option_random = params.is_option_random ? 1 : 0;
        params.is_show_answer = params.is_show_answer ? 1 : 0;
        params.is_repeat = params.is_repeat ? 1 : 0;
        params.ai = params.ai ? 1 : 0;
        params.notice = params.notice ? 1 : 0;
        params.ai = params.ai ? 1 : 0;

        if (_this.is_late == false) {
          params.late = 0;
        }
        if (_this.set_time == 0) {
          _this.weekly_time = "1";
          params.weekly = 0;
        } else {
          params.weekly_time =
            _this.weekly_time_start + "-" + _this.weekly_time_end;
        }
        _this.$http
          .post(process.env.VUE_APP_URL + "paperUpdate", params)
          .then(function (data) {
            if (data.data.code == 200) {
              _this.$message.success("保存成功！");
              _this.link("PaperListIndex");
              // _this.init()
            } else {
              _this.$message.error(data.data.msg);
            }
          })
          .catch(function (error) {
            _this.$message.error("网络错误,请刷新界面重试");
            return;
          });
      },
      quickMadePaper() {
        let _this = this,
          id = this.$route.params.id;
        let params = {
          id: id,
          radio: this.radio,
          radioChapter_id: this.radioChapter_id ? this.radioChapter_id[1] : "",
          radioDifficult: this.radioDifficult,
          radioKeyword: this.radioKeyword,
          checkbox: this.checkbox,
          checkboxChapter_id: this.checkboxChapter_id
            ? this.checkboxChapter_id[1]
            : "",
          checkboxDifficult: this.checkboxDifficult,
          checkboxKeyword: this.checkboxKeyword,
          judgement: this.judgement,
          judgementChapter_id: this.judgementChapter_id
            ? this.judgementChapter_id[1]
            : "",
          judgementDifficult: this.judgementDifficult,
          judgementKeyword: this.judgementKeyword,
          cloze: this.cloze,
          clozeChapter_id: this.clozeChapter_id ? this.clozeChapter_id[1] : "",
          clozeDifficult: this.clozeDifficult,
          clozeKeyword: this.clozeKeyword,
        };
        _this.$http
          .post(process.env.VUE_APP_URL + "bankRandomInsert", params)
          .then(function (data) {
            if (data.data.code == 200) {
              _this.madePaperquick = false;
              _this.init();
            } else {
              _this.$message.error(data.data.msg);
            }
          })
          .catch(function (error) {
            _this.$message.error({ message: "网络错误,请刷新界面重试" });
            return;
          });
      },
      handleMadePaper() {
        this.madePaper = false;
        this.init();
      },
      toDelete() {
        let _this = this;
        _this.$http
          .post(process.env.VUE_APP_URL + "questionDelete", this.params)
          .then(function (data) {
            if (data.data.code == 200) {
              _this.$message.success("试题删除成功！");
              _this.todel = false;
              _this.onSubmit();
            } else {
              _this.$message.error(data.data.msg);
            }
          });
      },
      addQues() {
        this.editType = null;
        this.ques = null;
        this.addQuestion = true;
      },
      link(path) {
        this.$router.push({ name: path });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      qiniuToken() {
        let _this = this;
        this.$http
          .get(process.env.VUE_APP_URL + "qiniuToken")
          .then(function (data) {
            if (data.data.code == 200) {
              if (data.data.msg) {
                _this.token = data.data.msg.uptoken;
              }
            }
          })
          .catch(function (error) {
            _this.$message.error({ message: "网络错误,请刷新界面重试" });
            return;
          });
      },
      beforeUpload(file) {
        let _this = this;
        const isJPG = file.type == "image/jpeg";
        const isLt2M = file.size / 1024 / 1024 < 15;

        if (file.type == "image/jpeg") {
          _this.ext = "jpeg";
        }
        if (file.type == "image/jpg") {
          _this.ext = "jpg";
        }
        if (file.type == "image/png") {
          _this.ext = "png";
        }

        if (
          !file.type == "image/jpg" ||
          !file.type == "image/jpeg" ||
          !file.type == "image/png"
        ) {
          this.$message.error("上传图片只能是 JPG、PNG、JPEG 格式!");
        }
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 15MB!");
        }
        _this.fullscreenLoading = true;
        //let _this = this;

        let observer = {
          next(res) {
            _this.percent = parseInt(res.total.percent);
          },
          error(err) {
            //  console.log(err)
          },
          complete(res) {
            _this.imageUrl =
              "https://resource.edc.org.cn/" +
              res.key +
              "?imageMogr2/thumbnail/200x200";

            let quill = _this.$refs.myQuillEditor.quill;
            // 如果上传成功
            // 获取光标所在位置
            let length = quill.getSelection().index;
            // 插入图片  res.info为服务器返回的图片地址
            quill.insertEmbed(length, "image", _this.imageUrl);
            // 调整光标到最后
            quill.setSelection(length + 1);
          },
        };
        let time = new Date().getTime();
        _this.key = "KsNetban/" + time;
        let key = _this.key + "." + _this.ext;
        let observable = qiniu.upload(
          file,
          key,
          _this.token,
          _this.CoverputExtra,
          _this.config
        );
        let subscription = observable.subscribe(observer); // 上传开始
      },
    },
  };
</script>
<style lang="less" scoped>
  .icon-wenhao {
    color: #c1c1c1;
    padding-left: 30px;
    font-size: 12px;
    cursor: pointer;
  }

  .warning span {
    color: red;
  }

  .addpaper {
    padding: 0px 40px 10px 20px;
    font-size: 14px;

    p {
      margin: 0;
      padding: 5px;
    }

    .choseType {
      position: fixed;
      z-index: 999;
      padding: 10px 40px 0 0px;
      top: 60px;
      height: 60px;
      line-height: 60px;
      background-color: #f0f3f4;
      width: 100%;
    }

    .el-radio-button {
      margin: 0 10px 20px 0;
    }

    .ruleForm {
      margin-top: 60px;
      padding: 20px;
      background-color: #fff;
      font-weight: bolder;

      /deep/.el-upload-dragger {
        width: 240px;
        height: 120px;
      }
    }

    .submint-btn {
      margin: 0;
      text-align: center;
      padding-bottom: 20px;
      background-color: #fff;
    }

    .ques {
      margin: 0;
      padding: 0 20px;
      background-color: #fff;

      .insertQues {
        color: #1989fa;
      }

      .oprate {
        text-align: right;
      }
    }
  }

  /deep/.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }

  .avatarOuter {
    width: 300px;
  }

  /deep/.avatar {
    width: 100% !important;
    display: block;
  }

  .is_right {
    color: #409eff;
  }

  .item_option {
    text-indent: 2em;
  }

  .el-card {
    margin-bottom: 5px;
  }

  .el-row {
    margin-bottom: 10px;
  }

  .zujuan {
    text-align: center;
  }

  .queTitle {
    display: flex;
    position: relative;
  }

  // .queTitle p {
  //   margin: 18px 0;
  //   padding: 0;
  //   font-size: 14px;
  //   height: 20px;
  //   line-height: 20px;
  // }
  .queType {
    position: absolute;
    right: 0px;
    color: #67c23a;
  }

  .msg {
    text-align: center;
  }

  .queName {
    width: 80%;
    overflow-wrap: break-word;
  }

  .el-radio {
    margin-right: 30px !important;
  }

  h2 {
    border-bottom: 1px solid #eee;
    padding-bottom: 8px;
    width: 500px;
  }

  .el-select {
    padding-right: 30px;
    width: 120px;
  }

  .ques_sum {
    padding-right: 30px;
  }

  .quill-editor {
    /deep/ .ql-container.ql-snow {
      background-color: #fff !important;
      height: 100px !important;
      font-weight: 400;
    }
  }

  .editorUploader {
    display: none;
  }
</style>